import React from "react"
import styled from "styled-components"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import Card from "./Card"
import OverviewSimple from "./OverviewSimple"

const StyledCard = styled(Card)`
  display: flex;
  align-items: center;
  margin: 10px 0;
  box-shadow: var(--shadow-elavated);
`

const Icon = styled(FontAwesomeIcon)``


type Props = {
  name: string
  icon: IconDefinition
  iconcolor: string
}

const ActivityTag = ({name, icon, iconcolor}: Props) => 
  <StyledCard>
    <OverviewSimple
      graphic={<Icon icon={icon} color={iconcolor}/>}
      maintext={name}
      />
  </StyledCard>

export default ActivityTag